// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ZHcRcT_OAy8ORFApvvr4K","groupsList":"_2qxvd-Mt40mIhk_4NfknEw"};